const general_tests_en = require('./general_tests.json')
export default general_tests_en